import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { alpha } from "@mui/material/styles";
import ArchiveIcon from "@mui/icons-material/Archive";
import React from "react";
import { ArchiveGroupModalController, ArchiveGroupModalControllerDelegate } from "./controller";

/** A ação é destrutiva: o ícone do título troca o azul do tema pelo vermelho. */
const destructiveTitleSx = {
  "& svg": {
    color: "error.main",
    backgroundColor: (theme: any) => alpha(theme.palette.error.light, 0.35),
  },
};

interface State {
  isLoading: boolean;
  errorMessage: string;
}

interface Props {
  groupId: string;
  delegate: ArchiveGroupModalDelegate;
}

export interface ArchiveGroupModalDelegate {
  shouldCloseArchiveModal: () => void;
  shouldLogout: () => void;
  didArchiveGroup: () => void;
}

class ArchiveGroupModal extends React.Component<Props, State> implements ArchiveGroupModalControllerDelegate {
  controller: ArchiveGroupModalController

  constructor(props: Props) {
    super(props);
    this.state = {
      isLoading: false,
      errorMessage: "",
    }
    this.controller = new ArchiveGroupModalController(this);
  }

  // delegate
  didArchiveGroup(){
    this.props.delegate.didArchiveGroup();
  }

  didFailArchiveGroup(message: string) {
    this.setState({ isLoading: false, errorMessage: message });
  };

  groupShouldLogout() {
    this.props.delegate.shouldLogout();
  };

  // internals
  didClickDelete() {
    this.setState({ isLoading: true, errorMessage: "" });
    const token = localStorage.getItem("AccessToken")!;
    this.controller.archiveGroup(token, this.props.groupId)
  }

  didClickClose() {
    if (this.state.isLoading) {
      return;
    }
    this.props.delegate.shouldCloseArchiveModal();
  }

  renderLoading() {
    return (
      <Box
        alignItems="center"
        display="flex"
        flexDirection="column"
        justifyContent="center"
        gap={2}
        paddingY={5}
      >
        <CircularProgress color="error" />
        <Typography variant="body2" color="text.secondary">
          Arquivando devolutiva agregada...
        </Typography>
      </Box>
    );
  }

  renderForm() {
    return (
      <Box display="flex" flexDirection="column" sx={{ gap: 2 }}>
        {this.state.errorMessage && (
          <Alert
            severity="error"
            onClose={() => this.setState({ errorMessage: "" })}
          >
            {this.state.errorMessage}
          </Alert>
        )}

        <Typography color="text.secondary">
          Tem certeza que deseja arquivar esta devolutiva agregada?
        </Typography>

        <Alert severity="warning">
          Você apenas poderá restaurá-la entrando em contato com a
          administração.
        </Alert>
      </Box>
    );
  }

  // Internals
  render() {
    return (
      <Dialog
        open
        onClose={() => this.didClickClose()}
        variant="modal"
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle variant="modal" sx={destructiveTitleSx}>
          <ArchiveIcon />
          Arquivar devolutiva agregada
        </DialogTitle>
        <DialogContent variant="modal">
          {this.state.isLoading ? this.renderLoading() : this.renderForm()}
        </DialogContent>
        {!this.state.isLoading && (
          <DialogActions
            variant="modal"
            sx={{ flexWrap: "wrap", gap: 1, justifyContent: "end" }}
          >
            <Button
              variant="outlined"
              color="error"
              onClick={() => this.didClickClose()}
            >
              Cancelar
            </Button>

            <Button
              variant="contained"
              color="error"
              onClick={() => this.didClickDelete()}
            >
              Arquivar Devolutiva Agregada
            </Button>
          </DialogActions>
        )}
      </Dialog>
    );
  }
}

export default ArchiveGroupModal;
